const municipalities = ['110000', '120000', '310000', '500000'];

/** 判断节点是否为直辖市。 */
export function isMunicipality(code) {
  return municipalities.includes(String(code));
}

/** 补齐因父节点缺失而未进入三级树的区县，保留已有节点和原路径。 */
export function completeMunicipalities(tree, source, codeToText) {
  tree.filter(node => isMunicipality(node.value)).forEach(province => {
    const known = new Set();
    (province.children || []).forEach(city => (city.children || []).forEach(district => known.add(String(district.value))));
    source.forEach((children, parentCode) => {
      if (!children || typeof children.forEach !== 'function') return;
      children.forEach((label, code) => {
        code = String(code);
        if (!/^\d{6}$/.test(code) || code.slice(0, 2) !== String(province.value).slice(0, 2) || code.endsWith('00') || known.has(code)) return;
        const middleCode = /^\d{6}$/.test(String(parentCode)) ? String(parentCode) : code.slice(0, 4) + '00';
        province.children = province.children || [];
        let city = province.children.find(node => String(node.value) === middleCode);
        if (!city) {
          city = { value: middleCode, label: codeToText[middleCode] || '市辖区', children: [] };
          province.children.push(city);
          codeToText[middleCode] = city.label;
        }
        city.children = city.children || [];
        city.children.push({ value: code, label });
        codeToText[code] = label;
        known.add(code);
      });
    });
  });
}

/** 只投影直辖市的展示树，同时记录每个区县对应的原三级路径。 */
export function projectRegions(options) {
  const paths = new Map();
  const nodes = (options || []).map(province => {
    if (!isMunicipality(province.value)) return province;
    const districts = [];
    const seen = new Set();
    (province.children || []).forEach(city => {
      (city.children || []).forEach(district => {
        const code = String(district.value);
        if (seen.has(code)) return;
        seen.add(code);
        districts.push(district);
        paths.set(code, [province.value, city.value, district.value]);
      });
    });
    return { ...province, children: districts.length ? districts : undefined };
  });
  return { options: nodes, paths };
}

/** 将历史三级路径投影为界面两级路径；非直辖市及单值模式原样返回。 */
export function displayRegionValue(value, multiple = false, emitPath = true) {
  if (multiple) return Array.isArray(value) ? value.map(item => displayRegionValue(item, false, emitPath)) : value;
  if (!emitPath || !Array.isArray(value) || !isMunicipality(value[0])) return value;
  return value.length > 2 ? [value[0], value[value.length - 1]] : value.length === 2 && String(value[1]).endsWith('00') ? [value[0]] : value;
}

/** 将界面选择恢复为原三级编码，已存在的历史路径优先原样保留。 */
export function restoreRegionValue(value, previous, paths, multiple = false, emitPath = true) {
  if (multiple) return Array.isArray(value) ? value.map(item => {
    const old = Array.isArray(previous) ? previous.find(candidate => JSON.stringify(displayRegionValue(candidate, false, emitPath)) === JSON.stringify(item)) : undefined;
    return restoreRegionValue(item, old, paths, false, emitPath);
  }) : value;
  if (!emitPath || !Array.isArray(value) || !isMunicipality(value[0])) return value;
  if (value.length === 2 && Array.isArray(previous) && previous.length >= 3 && JSON.stringify(displayRegionValue(previous)) === JSON.stringify(value)) return previous;
  return value.length === 2 ? (paths.get(String(value[1])) || value).slice() : value;
}
